if( !customElements.get('anchor-nav') ){
  customElements.define(
    'anchor-nav',
    class AnchorNav extends HTMLElement {
      constructor() {
        super();
      }
      SHOPIFY_SECTION = 'shopify-section';

      connectedCallback() {
        this.init();
      }

      getTargetId(suffixTargetId) {
        return this.SHOPIFY_SECTION + '-' + this.sectionIdPrefix + '__' + suffixTargetId;
      }


      init() {
        this.sectionIdPrefix = this.dataset.sectionIdPrefix || '';

        this.buttons = this.querySelectorAll('.anchor-btn');
        this.buttons.forEach((item) => {
          const targetIds = item.getAttribute('data-anchor-link').split(',');
          const fullTargetIds = targetIds.map((targetId) => {
            return this.getTargetId(targetId);
          })
          item.addEventListener('click', this.onAnchorBtnClick(fullTargetIds));
        });

        // 监控target是否滚动到位置 用onscroll 
        window.addEventListener('scroll', this.onScroll);

      }

      // 当组件卸载 断开所有observer
      disconnectedCallback() {
        this.observer.disconnect();
        window.removeEventListener('scroll', this.onScroll);
      }

      onScroll = () => {
        if (this.isAnimate){
          return;
        }
        const topOffset = this.getTopOffset();
        const windowHeight = window.innerHeight;
        const windowMiddle = window.scrollY + windowHeight / 2;
        
        // 存储所有可见元素及其位置信息
        const visibleItems = [];
        
        // 先计算所有元素的位置和与视口的匹配程度
        this.buttons.forEach((item) => {
          const suffixTargetIds = item.getAttribute('data-anchor-link').split(',');
          const targetIds = suffixTargetIds.map((targetId) => {
            return this.getTargetId(targetId);
          })
          // 获取的是targets的第一个元素的top 和最后一个元素的bottom
          const firstTargetElement = document.getElementById(targetIds[0]);
          const lastTargetElement = document.getElementById(targetIds[targetIds.length - 1]);
          
          if (!firstTargetElement || !lastTargetElement) {
            return;
          }
          
          const targetTop = firstTargetElement.offsetTop - topOffset;
          const targetHeight = lastTargetElement.offsetTop + lastTargetElement.offsetHeight - targetTop;
          const targetBottom = targetTop + targetHeight;
          const targetCenter = targetTop + targetHeight / 2;
          
          // 计算元素与视口中间位置的距离
          const distanceToMiddle = Math.abs(windowMiddle - targetCenter);
          
          // 如果元素部分或完全在视口中，将其添加到可见列表
          if (windowMiddle >= targetTop && windowMiddle <= targetBottom) {
            visibleItems.push({
              button: item,
              distance: distanceToMiddle,
              targetTop: targetTop
            });
          }
        });
        
        // 首先移除所有按钮的active状态
        this.buttons.forEach((item) => {
          item.removeAttribute('data-active');
        });
        
        // 如果有可见元素，找到最合适的一个激活
        if (visibleItems.length > 0) {
          // 排序：首先按距离视口中间的远近排序，距离近的优先
          // 如果距离相同，则按位置排序，位置靠上的优先
          visibleItems.sort((a, b) => {
            if (a.distance !== b.distance) {
              return a.distance - b.distance;
            }
            return a.targetTop - b.targetTop;
          });
          
          // 只激活最匹配的一个按钮
          visibleItems[0].button.setAttribute('data-active', 'true');
          
          // 滚动使激活的按钮在容器内可见
          this.scrollButtonIntoView(visibleItems[0].button);
        }
      }



      getTopOffset() {
        const stickyOffset = getComputedStyle(this).getPropertyValue('--sticky-offset').trim();
        const newHeaderHeight = getComputedStyle(this).getPropertyValue('--header-height').trim();
        const newHeaderNavigationHeight = getComputedStyle(this).getPropertyValue('--header-navigation-height').trim();

        const topOffset = parseFloat(newHeaderHeight) - parseFloat(newHeaderNavigationHeight) - parseFloat(stickyOffset) - 0.1 + this.offsetHeight;
        return topOffset;
      }

      onAnchorBtnClick = (targetIds) => {
        return (e) => {
          e.preventDefault();
           
          // 激活当前button
          this.buttons.forEach((item) => {
            item.removeAttribute('data-active');
          });
          const activeButton = e.target.closest('.anchor-btn');
          activeButton.setAttribute('data-active', 'true');
          
          // 滚动使激活的按钮在容器内可见
          this.scrollButtonIntoView(activeButton);

          const targetElement = document.getElementById(targetIds[0]);
          if (targetElement) {
            // 设置滚动动画标志
            this.isAnimate = true;
            
            // 清理之前可能存在的监听器和定时器，避免多个滚动动画同时进行
            if (this.scrollEndTimeout) {
              clearTimeout(this.scrollEndTimeout);
            }
            if (this.scrollEndHandler) {
              window.removeEventListener('scroll', this.scrollEndHandler);
            }
            
            // 滚动到目标位置
            window.scrollTo({
              top: targetElement.offsetTop - this.getTopOffset(),
              behavior: 'smooth'
            });
            
            // 创建滚动结束检测函数并保存引用
            this.scrollEndHandler = () => {
              // 检查滚动是否基本停止（通过比较连续两次滚动位置）
              if (this.lastScrollY === window.scrollY) {
                this.isAnimate = false;
                window.removeEventListener('scroll', this.scrollEndHandler);
                this.scrollEndHandler = null;
              }
              this.lastScrollY = window.scrollY;
            };
            
            // 添加滚动事件监听器
            window.addEventListener('scroll', this.scrollEndHandler);
            
            // 设置超时清理，确保即使滚动事件未触发也能重置状态
            this.scrollEndTimeout = setTimeout(() => {
              this.isAnimate = false;
              if (this.scrollEndHandler) {
                window.removeEventListener('scroll', this.scrollEndHandler);
                this.scrollEndHandler = null;
              }
            }, 1000);
          }
        }
      }
      
      // 将激活的按钮滚动到其容器的可见区域
      scrollButtonIntoView(button) {
        const container = button.closest('.anchor-nav__content');
        const item = button.parentElement;
        if (container) {
          // 计算按钮相对于容器的位置
          const buttonLeft = item.offsetLeft;
          const buttonWidth = item.offsetWidth;
          const containerScrollLeft = container.scrollLeft;
          const containerWidth = container.clientWidth;
          
          // 判断按钮是否已经在可见区域内
          // 如果按钮左侧超出容器左侧，或者右侧超出容器右侧，则需要滚动
          if (buttonLeft < containerScrollLeft || 
              buttonLeft + buttonWidth > containerScrollLeft + containerWidth) {
            
            // 计算滚动位置，使按钮居中或适当调整
            // 这里使用按钮左侧位置减去容器宽度的四分之一，使按钮更靠左显示
            const targetScrollLeft = buttonLeft - containerWidth / 4;
            
            // 平滑滚动到目标位置
            container.scrollTo({
              left: Math.max(0, targetScrollLeft),
              behavior: 'smooth'
            });
          }
        }
      }

    }
  )



}